/** Seeded pseudo-random generator returning numbers in [0, 1). GDD §15.3: the core never uses Math.random(). */
export type Rng = () => number;

/** mulberry32: small, fast and good enough for gameplay determinism. */
export function createRng(seed: number): Rng {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
